import React from 'react';
import { 
  Hammer, 
  UserCheck, 
  Sprout, 
  Lightbulb, 
  Puzzle, 
  Users 
} from 'lucide-react';
import './ValuesSection.css';
import one from './1.jpg';
const ValuesSections = () => {
  return (
    <section className="values-section">
      <div className="containers">
        {/* Main Heading */}
        <h2 className="main-heading">What We Believe In</h2>

        <div className="values-layout">
          
          {/* Left Column */}
          <div className="values-column side-column">
            <FeatureItem 
              icon={<Hammer strokeWidth={1} size={40} />}
              title="Built by Masters, Made to Last."
              desc="Expert workmanship meets considered design to deliver pieces that look beautiful and endure daily life."
            />
            
            <FeatureItem 
              icon={<UserCheck strokeWidth={1} size={40} />}
              title="Centered on Customers"
              desc="Every interaction is personalized, every solution is tailored, and every detail is designed to delight from first consult to after-care."
            />
            
            <FeatureItem 
              icon={<Sprout strokeWidth={1} size={40} />}
              title="Eco-Conscious by Design"
              desc="Sustainable woods, low-VOC finishes, and recyclable packaging for pieces that are better for home and earth."
            />
          </div>

          {/* Center Column (Image) */}
          <div className="values-column center-column">
            <div className="image-frame">
              <img 
                src={one} 
                alt="Minimalist Wood Interior" 
                className="center-img"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="values-column side-column">
            <FeatureItem 
              icon={<Lightbulb strokeWidth={1} size={40} />}
              title="Creativity with Purpose"
              desc="Bold concepts shaped into functional forms that elevate everyday living and stand the test of time."
            />
            
            <FeatureItem 
              icon={<Puzzle strokeWidth={1} size={40} />}
              title="Honesty at the Core"
              desc="Straightforward communication and ethical conduct guide decisions, partnerships, and daily work."
            />
            
            <FeatureItem 
              icon={<Users strokeWidth={1} size={40} />}
              title="Co-create, Grow, Repeat"
              desc="Working side by side with teams and partners to unlock ideas, refine solutions, and scale success."
            />
          </div>

        </div>
      </div>
    </section>
  );
};

// Helper Component for the individual items
const FeatureItem = ({ icon, title, desc }) => (
  <div className="feature-item">
    <div className="icon-wrapper">
      {icon}
    </div>
    <h3 className="feature-title">{title}</h3>
    <p className="feature-desc">{desc}</p>
  </div>
);

export default ValuesSections;